/**
 * src/utils/dom.js
 *
 * Helper genérico de DOM access. Reemplaza el bridge window.appRoot
 * que vivía en src/main.js post-3.15 (DT-10).
 *
 * El nodo #app-root es el root de la aplicación, declarado en index.html
 * dentro de <main id="app-root">. Existe siempre que el HTML esté parseado.
 *
 * Migrado en sub-fase 3.16 — cierre formal de FASE 3.
 */

export const appRoot = typeof document !== 'undefined' ? document.getElementById('app-root') : null;
